module.exports = __webpack_public_path__ + "static/media/user.80ab6a28.svg";